import { render, staticRenderFns } from "./replenish.vue?vue&type=template&id=b5b6dfc2&scoped=true"
import script from "./replenish.vue?vue&type=script&lang=js"
export * from "./replenish.vue?vue&type=script&lang=js"
import style0 from "./replenish.vue?vue&type=style&index=0&id=b5b6dfc2&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b6dfc2",
  null
  
)

export default component.exports